import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label } from 'reactstrap';
import InputMask from 'react-input-mask';
import { setGoalRequest } from '../../api/controller/RaceKitController';
import { handleResponse } from '../helpers/HandleResponse';
import { Loader } from './Loader';

export const GoalModal = ({ isOpen, toggle, raceKit, onSuccess }) => {
    const [expectedFinishTime, setExpectedFinishTime] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isOpen && raceKit) {
            setExpectedFinishTime(raceKit.expected_finish_time || '');
            setTimeout(() => {
                const ele = document.getElementById('expectedFinishTime');
                if (ele) {
                    // select all text if exists else just focus
                    if (ele.value) {
                        ele.select();
                    } else {
                        ele.focus();
                    }
                }
            }, 100);
        }
    }, [isOpen, raceKit]);

    // The mask leaves its own placeholder behind ("__:__:__") when the field is wiped
    // rather than retyped, so "empty" is not always "". Anything with no digit left in it
    // is a clear; a half-typed "01:2_:__" still goes to the server, which reports it as
    // the format error it is.
    const isBlank = !/\d/.test(expectedFinishTime);

    const submitGoal = async (value) => {
        if (!raceKit) return;

        setIsLoading(true);
        try {
            const response = await setGoalRequest({
                id: raceKit.id,
                ExpectedFinishTime: value
            });

            handleResponse(response);

            // Check if the response was successful
            if (response?.Status === 'success') {
                if (onSuccess) {
                    onSuccess();
                }
                // Close modal immediately after successful save
                toggle();
            }
        } catch (error) {
            console.error('Error setting goal:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Submitting an emptied field is a clear, so Enter does the same thing the
        // Clear button does rather than erroring on the mask placeholder.
        submitGoal(isBlank ? '' : expectedFinishTime);
    };

    const handleClear = () => submitGoal('');

    const handleClose = () => {
        setExpectedFinishTime('');
        setIsLoading(false);
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose} size="sm" keyboard={false} backdrop="static">
            <Loader loading={isLoading} transparent />
            <ModalHeader toggle={handleClose}>
                Set Goal - {raceKit?.bib_number}
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <FormGroup>
                        <Label for="expectedFinishTime">Expected Finish Time</Label>
                        <InputMask
                            id="expectedFinishTime"
                            className="form-control"
                            mask="99:99:99"
                            value={expectedFinishTime}
                            onChange={(e) => setExpectedFinishTime(e.target.value)}
                            placeholder="HH:MM:SS"
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter className="justify-content-between">
                    {/* Only offered when there is a stored goal to remove -- on a kit that
                        has none it would be a button that does nothing. */}
                    {raceKit?.expected_finish_time ? (
                        <Button color="link" className="text-danger p-0" onClick={handleClear}>
                            Clear goal
                        </Button>
                    ) : <span />}
                    <div className="d-flex gap-2">
                        <Button color="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button color="primary" type="submit">
                            Save
                        </Button>
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    );
};
